module.exports = __webpack_public_path__ + "static/media/picto-love.b42d217d.svg";